import React from 'react'
import Simplecard from '../Cards/Simplecard'
import CartItems from '../Cards/CartItems'
import CouponBox from '../Forms/CouponBox'
import PaymentDetails from '../Box/PaymentDetails'
const CartContainer = () => {
  return (
    <div className='flex flex-col tablet:flex-row justify-evenly '>
        <div className='w-full tablet:basis-7/12  '>
        <Simplecard/>
        <h1 className='p-2 text-2xl font-semibold '>Grocceries in Cart</h1>
        <CartItems/>
        <CartItems/>
        <CartItems/>
        </div>
        <div className='w-full tablet:basis-4/12 '>
         <CouponBox/>
         <PaymentDetails/>
        </div>
    </div>
  )
}

export default CartContainer